import { gql } from '@apollo/client';

export const GET_DOCUMENTS = gql`
  query GetDocuments($projectId: ID!) {
    documents(projectId: $projectId) {
      id
      originalName
      createdAt
      status
      uploadedBy {
        id
        email
      }
    }
  }
`;

export const GET_DOCUMENT_EXPLORER = gql`
  query GetDocumentExplorer($projectId: ID!, $folderId: ID) {
    documentExplorer(projectId: $projectId, folderId: $folderId) {
      currentFolder {
        id
        name
        parentId
        createdAt
        updatedAt
        createdBy {
          id
          email
        }
      }
      breadcrumb {
        id
        name
        parentId
        createdAt
        updatedAt
        createdBy {
          id
          email
        }
      }
      folders {
        id
        name
        parentId
        createdAt
        updatedAt
        createdBy {
          id
          email
        }
      }
      documents {
        id
        originalName
        createdAt
        status
        folderId
        uploadedBy {
          id
          email
        }
      }
    }
  }
`;

export const GET_DOCUMENT_FOLDERS = gql`
  query GetDocumentFolders($projectId: ID!) {
    documentFolders(projectId: $projectId) {
      id
      name
      parentId
      createdAt
      updatedAt
      createdBy {
        id
        email
      }
    }
  }
`;

export const GET_DOCUMENT_BREADCRUMB = gql`
  query GetDocumentBreadcrumb($id: ID!, $type: BreadcrumbItemType!, $projectId: ID!) {
    documentBreadcrumb(id: $id, type: $type, projectId: $projectId) {
      id
      name
      parentId
      type
    }
  }
`;

export const GET_DOCUMENT = gql`
  query GetDocument($id: ID!, $projectId: ID!) {
    document(id: $id, projectId: $projectId) {
      id
      originalName
      mimeType
      sizeBytes
      status
      processedAt
      createdAt
      folderId
      commentCount
      uploadedBy {
        id
        email
      }
      formFields {
        id
        name
        isRequired
        type
        suggestionGenerationStatus
        recommendationGenerationStatus
        recommendation {
          id
          targetType
          suggestedValue
          explanation
          confidenceScore
          status
          feedback
        }
        suggestions {
          id
          confidenceScore
          explanation
          sourceType
          targetType
          sourceDataPoint {
            id
            title
            value
            type
            facility {
              id
              name
            }
          }
          sourceDocumentChunk {
            id
            content
            pageIndex
            document {
              id
              originalName
            }
          }
          internetContent {
            id
            url
            title
            content
          }
          sourceEmissionFactor {
            id
            provider
            providerFactorId
            dataVersion
            name
            activityKey
            category
            scopes
            hierarchy
            source
            sourceDataset
            region
            regionName
            year
            unit
            unitType
            co2eFactor
          }
        }
        widgets {
          id
          x
          y
          width
          height
          pageNumber
          value
          pdfOptionName
        }
      }
    }
  }
`;

export const GET_SIGNED_PREVIEW_URL = gql`
  query GetSignedPreviewUrl($id: ID!, $projectId: ID!) {
    getSignedPreviewUrl(id: $id, projectId: $projectId) {
      document {
        id
      }
      signedUrl
    }
  }
`;
